import { render, staticRenderFns } from "./FbpComponentsForm.vue?vue&type=template&id=283a9b6e&scoped=true"
import script from "./FbpComponentsForm.vue?vue&type=script&lang=js"
export * from "./FbpComponentsForm.vue?vue&type=script&lang=js"
import style0 from "./FbpComponentsForm.vue?vue&type=style&index=0&id=283a9b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a9b6e",
  null
  
)

export default component.exports